module.exports = __webpack_public_path__ + "img/sia.9060f972.jpg";